module.exports = __webpack_public_path__ + "media/iconic/layers-627f6129.svg";